// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Minimum available (bookable) slots within the rolling horizon window
 */
export type EventKindCoverageMinAvailableSlotsRolling = number | null;
